import React, { memo, Fragment } from 'react';
import { Drawer } from '@Sage/hoi-poi-ui';
import ContentWrapper from './ContentWrapper';
import { FiltersContext, FiltersProvider, FiltersConsumer } from './Context';
import { operators, fieldOperators } from './operators';

const Filters = memo(({ isOpen, useDrawer = true, side = 'right', ...props }) => {
    return (
        <Fragment>
            {useDrawer && (
                <Drawer
                    side={side}
                    isOpen={isOpen}
                    width="400px"
                    shouldCloseOnOverlayClick={true}
                    hideOverlay={true}
                    className="fm-filters--drawer"
                >
                    {<ContentWrapper isOpen={isOpen} {...props} />}
                </Drawer>
            )}
            {!useDrawer && <ContentWrapper {...props} />}
        </Fragment>
    );
});

export default Filters;

export { FiltersContext, FiltersProvider, FiltersConsumer, operators, fieldOperators };
